import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c90d6f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switch-label" }, "弹幕审核设置:", -1))
const _hoisted_3 = { class: "switch-tip" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {ref} from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import {useStore} from '@/store'
import {downloadData, getListData, postData} from "@/service/main/system";
import {ElLoading, ElMessage} from "element-plus";
import {ElMessageBox} from "element-plus/es";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoChat',
  setup(__props) {

const store = useStore()

const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
}

const editCb = () => {
  modalTitle.value = '编辑'
}

// 获取审核状态
const getReviewStatus = async () => {
  getListData('/main/autoChat/getReviewStatus', {}).then((res) => {
    switchValue.value = Number(res)
  })
}

getReviewStatus()

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  initData()
}

const filterRules = [
  '温馨提示：',
  '弹幕是否需要审核、当天需要发送的弹幕，请在 18:00 前完成录入'
]

const handleDownloadImport = () => {
  const fileName = '弹幕导入模板.xlsx'
  downloadData(
    '/main/autoChat/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}
let loadingInstance = ref<any>()
const handleImportProgress = (res: any) => {
  loadingInstance.value = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
const handleImportSuccess = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if (res && res.code) {
      ElMessage({
        type: 'warning',
        message: res.message
      })
    } else {
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick()
    }
  }
}

const handleImportError = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  ElMessage({
    type: 'error',
    message: res.message
  })
}


const switchValue = ref(0)
const handleSwitchChange = (val: number) => {
  const statusText = val === 1 ? ' 关闭审核 ' : ' 需要审核 '

  ElMessageBox.confirm(
    `确定要${statusText}吗？`,
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(async () => {
    try {
      await postData("/main/autoChat/updateReview", {reviewStatus: switchValue.value});
    } catch (error) {
    }
  }).catch(() => {
    switchValue.value = val === 1 ? 0 : 1
  })
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_el_card, {
      class: "switch-card",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_switch, {
            modelValue: switchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((switchValue).value = $event)),
            "active-value": 1,
            "inactive-value": 0,
            "active-text": "关闭审核",
            "inactive-text": "开启审核",
            "inline-prompt": "",
            onChange: handleSwitchChange
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", _hoisted_3, "当前状态：" + _toDisplayString(switchValue.value === 1 ? '弹幕关闭审核' : '弹幕开启审核'), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "autoChat",
      downFilename: "定时弹幕.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError,
      onYbwaveDownloadImport: handleDownloadImport,
      onSortChange: handleSortChange,
      deleteTip: "确认删除此项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      filterRules: filterRules
    }, {
      sendStatus: _withCtx((scope) => [
        (scope.row.sendStatus === '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "待发送"))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "已发送"))
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "autoChat",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})